import { render, staticRenderFns } from "./GamesByTagsBox.vue?vue&type=template&id=151d9462&scoped=true&lang=pug&"
import script from "./GamesByTagsBox.vue?vue&type=script&lang=js&"
export * from "./GamesByTagsBox.vue?vue&type=script&lang=js&"
import style0 from "./GamesByTagsBox.vue?vue&type=style&index=0&id=151d9462&scoped=true&lang=css&"
import style1 from "./GamesByTagsBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d9462",
  null
  
)

export default component.exports